const Customization = () =>
  import("@/modules/customization/pages/Customization.vue");

export default [
  {
    path: "/customize",
    name: "customization",
    component: Customization,
    children: [],
    meta: {
      authRequired: true,
      isAdmin: true,
    },
  },
];
